import { red } from '@mui/material/colors';
import { createTheme, darken, lighten } from '@mui/material/styles';
import { esES } from '@mui/x-data-grid/locales';

export const primaryColor = '#70A83B';
export const secondaryColor = '#1540A0'; //#e52e80 or #b43c8d or #f155bd

// A custom theme for this app
const theme = createTheme({
    components: {
        // Name of the component
        MuiButton: {
            styleOverrides: {
                // Name of the slot
                root: {
                    // Some CSS
                    borderRadius: 24,
                },
            },
        },
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    '& .MuiDataGrid-cell:focus': {
                        outline: 'none'
                    },
                    '& .MuiDataGrid-cell:focus-within': {
                        outline: 'none'
                    },
                    '& .MuiDataGrid-cell:hover': {
                        cursor: 'pointer',
                    },
                },
            }
        },
    },
    palette: {
        type: 'light',
        primary: {
            light: lighten(primaryColor, 0.45),
            main: primaryColor,
            dark: darken(primaryColor, 0.45),
            contrastText: darken('#fff', 0.05),
        },
        secondary: {
            light: lighten(secondaryColor, 0.45),
            main: secondaryColor,
            dark: darken(secondaryColor, 0.45),
            contrastText: darken('#fff', 0.05),
        },
        error: {
            main: red.A400,
        },
    },

}, esES);

export default theme;